import React, { useState } from "react";
import { IconButton, Popover, Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import EmojiPicker from "emoji-picker-react";

export default function AnswerDetailsEditor({ value, onChange }) {
  const items = Array.isArray(value) ? value : [];
  const [emojiAnchor, setEmojiAnchor] = useState(null);
  const [activeEmojiIdx, setActiveEmojiIdx] = useState(null);

  const handleEmojiOpen = (e, idx) => {
    setEmojiAnchor(e.currentTarget);
    setActiveEmojiIdx(idx);
  };

  const handleEmojiClose = () => {
    setEmojiAnchor(null);
    setActiveEmojiIdx(null);
  };

  const handleEmojiSelect = (emojiData) => {
    if (activeEmojiIdx !== null) {
      updateAt(activeEmojiIdx, { ...items[activeEmojiIdx], emoji: emojiData.emoji });
    }
    handleEmojiClose();
  };

  const updateAt = (idx, next) => {
    const copy = [...items];
    copy[idx] = next;
    onChange?.(copy);
  };

  const addRow = () => {
    onChange?.([...items, { label: "", emoji: "", value: "" }]);
  };

  const removeAt = (idx) => {
    onChange?.(items.filter((_, i) => i !== idx));
  };

  return (
    <>
      {items.map((it, idx) => (
        <Grid container spacing={2} key={idx} sx={{ mb: 1 }}>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              size={"small"}
              label="Label"
              value={it?.label || ""}
              onChange={(e) => updateAt(idx, { ...it, label: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size={"small"}
              label="Emoji"
              value={it?.emoji || ""}
              onChange={(e) => updateAt(idx, { ...it, emoji: e.target.value })}
              InputProps={{
                endAdornment: (
                  <IconButton size="small" onClick={(e) => handleEmojiOpen(e, idx)}>
                    <InsertEmoticonIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              size={"small"}
              label="Value"
              value={it?.value || ""}
              onChange={(e) => updateAt(idx, { ...it, value: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={1} sx={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={() => removeAt(idx)}>
              <DeleteForeverIcon sx={{ color: "red" }} />
            </IconButton>
          </Grid>
        </Grid>
      ))}

      <IconButton onClick={addRow}>
        <AddCircleOutlineIcon />
      </IconButton>

      <Popover
        open={Boolean(emojiAnchor)}
        anchorEl={emojiAnchor}
        onClose={handleEmojiClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Box sx={{ p: 1 }}>
          <EmojiPicker onEmojiClick={handleEmojiSelect} width={350} height={400} />
        </Box>
      </Popover>
    </>
  );
}
